package com.arena_web.domain.usecases.auth

import com.arena_web.analytics.UtmCapture
import com.arena_web.data.dto.AuthResponse
import com.arena_web.data.dto.RegisterRequest
import com.arena_web.domain.repositories.AuthRepository

class RegisterUseCase(private val authRepository: AuthRepository) {

    suspend operator fun invoke(
        email: String,
        username: String,
        password: String,
        fullName: String? = null
    ): Result<AuthResponse> {
        val utm = UtmCapture.current()
        val result = authRepository.register(
            RegisterRequest(
                email = email,
                username = username,
                password = password,
                fullName = fullName,
                utmSource = utm?.utmSource,
                utmMedium = utm?.utmMedium,
                utmCampaign = utm?.utmCampaign,
                utmContent = utm?.utmContent,
                deviceId = UtmCapture.deviceId(),
                fbclid = UtmCapture.fbclid(),
                fbp = UtmCapture.fbp(),
                ttclid = UtmCapture.ttclid(),
                ttp = UtmCapture.ttp(),
            )
        )
        result.onSuccess { saveAuthSession(it) }
        return result
    }
}
